import { generateUniqueId } from '../../helpers/common';

export const SET_EMAIL = generateUniqueId();
export const SET_PASSWORD = generateUniqueId();